(function() {
  angular.module('general')
    .controller('infoController', ['$scope', 'secSecurityService', '$translate', '$rootScope',
      function ($scope, secSecurityService, $translate, $rootScope) {
        var vm = this;
        vm.terms = "";
        vm.restrictedTerms = "";
        vm.applicationName = $rootScope.applicationName;
        secSecurityService.hasAnyAuthority('DSO_ADMIN_USER').then((val) => {
          if(val) {
            $translate('content.registration.restrictedTerms').then((result) => {
              vm.restrictedTerms = result;
              $translate('content.registration.termsConditions', {restrictedTerms: vm.restrictedTerms}).then((result) => {
                vm.terms = result;
              });
            });
          } else {
            $translate('content.registration.termsConditions', {restrictedTerms: vm.restrictedTerms}).then((result) => {
              vm.terms = result;
            });
          }
        });
      }]);
})();
